<!-- 定位信息管理 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="fuzzy-matching-top">
      <el-row class="top-first-line the-second-line">
        <el-col :span="5">
          <el-form-item label="IMEI:">
            <el-input v-model="Dform.imei" placeholder=''></el-input>
          </el-form-item>
        </el-col >
          <el-col :span="5">
            <el-form-item label="起始：">
              <el-date-picker
                  v-model="Dform.startTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
        </el-col >
          <el-col :span="5">
            <el-form-item label="截止：">
              <el-date-picker
                  v-model="Dform.terminalTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col >
          <el-col :span="5">
          </el-col >
          
   
        <el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
      </el-row>
    </div>
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
         :border="true"
         :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
            <!-- <el-table-column
              prop="type"
              label="类型"
              >
            </el-table-column> -->
          <el-table-column
            prop="imei"
            label="IMEI"
            >
          </el-table-column>
            <el-table-column
            prop="cause"
            label='过滤原因'
            >
          </el-table-column>
          <el-table-column
            prop="lng1"
            label="经度"
            >
          </el-table-column>
          <el-table-column
            prop="lat1"
            label="纬度"
            >
          </el-table-column>

          <el-table-column
            prop="type"
            label="取点数据类型"
            >
            <template #default="scope">
              <el-button  type="text"   v-if="scope.row.type == 1">GPS</el-button>
              <el-button  type="text"   v-if="scope.row.type == 2">LBS</el-button>
              <el-button  type="text"   v-if="scope.row.type == 3">LBS/CDMN</el-button>
              <el-button  type="text"   v-if="scope.row.type == 4">WIFI</el-button>

            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="上报时间"
            >
          </el-table-column>
          <el-table-column
            label="状态"
            >
            <template #default="scope">
              <el-button class="statusBtn" type="text"  @click="statusClick(scope.row)" v-if="scope.row.status == 0">待定点</el-button>
              <el-button class="statusBtn" type="text"  @click="statusClick(scope.row)" v-if="scope.row.status == 1">正常</el-button>
              <el-button class="statusBtn" type="text"  @click="statusClick(scope.row)" v-if="scope.row.status == 2">过滤点</el-button>
              <el-button class="statusBtn" type="text"  @click="statusClick(scope.row)" v-if="scope.row.status == 3">定位点</el-button>
              <el-button class="statusBtn" type="text"  @click="statusClick(scope.row)" v-if="scope.row.status == 4">纠错点</el-button>
              <el-button class="statusBtn" type="text"  @click="statusClick(scope.row)" v-if="scope.row.status == 6">守护点</el-button>

            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            >
            <template #default="scope">
              <el-button class="shanchuBtn" type="text" size="small" @click="deleteClick(scope.row)" >删除</el-button>

            </template>
          </el-table-column>
          
        </el-table>

        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>

    </div>

  </div>
</template>

<script>
import {FindGpsInfo,DeleteGpsInfo,UpdateGpsInfo} from '@/assets/api/user'
export default {
  components: {
    
  },
  data() {
      return {
        Dform: {
          imei:'',
          started:'',
          expirationTime:'',
        },
        tableData:[],
        multipleSelection:[],
        pageInfo: {
            page: 1,
            pageSize: 8,
        },
        total:''
      };
  },
  created() {
    this.getFindGpsInfo()

  },
  mounted() {

  },
  methods: {
    handleCurrentChange(val) {
    console.log(`当前页: ${val}`);
    this.pageInfo.page = val
    this.getFindGpsInfo()
  },
    //删除
    deleteClick(row){

      this.$confirm('请确定要删除该定位点信息吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.gpslogClick(row)
                        
                    }).catch((err) => {
                        console.log(err,'关机');
                       
                    });

    },
    // 删除请求
    gpslogClick(row){
      DeleteGpsInfo(row.gpsId).then((res)=> {
        // console.log(res,'我是删除');
        this.getFindGpsInfo()
        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
      }).catch((err)=> {
        console.log(err,'我是删除');
        this.$message({
                            type: 'error',
                            message: err.response.data.msg
                        });

      })
    },
    //修改状态
    statusClick(row){
      // console.log('我是状态');
        this.$prompt('请输入状态代码【0，1，2，3，4】', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputErrorMessage: '修改状态成功'
          }).then(({ value }) => {
              // console.log(value,'85858');
              this.statusLogClick(row,value)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });       
          });

    },
    statusLogClick(row,value){
      UpdateGpsInfo(row.gpsId,value).then((res) => {
        // console.log(res,'状态');
        this.getFindGpsInfo()

      }).catch((err) => {
        console.log(err);
      })
    },
    entrylogClick(){
    this.getFindGpsInfo()

    },
    getFindGpsInfo(){
      const params = {
        endTime:this.Dform.expirationTime,
        startTime:this.Dform.started,
        imei:this.Dform.imei,
        page:this.pageInfo.page,
        pageSize:this.Dform.pageSize,
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      FindGpsInfo(params).then((res) => {
        console.log(res,'11111111');
        this.tableData = res.data.data.list
        this.total =  res.data.data.total
      }).catch((err) => {
        console.log(err,'2222222');
      })

    }
  },
};
</script>

<style scoped lang="scss">
  .fuzzy-matching-box {
    padding-top: 20px;
    // overflow: hidden;
    // overflow: auto;
    width: 100%;
    height:  92%;
    background-color: #fff;
    border-radius: 8px;
    .title-top {
        padding: 20px 20px;
    }
    .fuzzy-matching-top {
    height: 60px ;
    background-color: #fff;
    border-radius: 8px;
    .top-first-line {
      // justify-content: center 
      // justify-content: space-between
      justify-content: space-around;
      :deep() {
        .el-form-item--small .el-form-item__label {
          // background-color: red;
          font-size: 16px;
        }
        .el-select--small {
            width: 100%
        }
        .el-form-item--small .el-form-item__label {
          font-weight: 700;
          width: 110px;
          text-align: right;
          height: 35px;
          line-height: 35px;          
        }
        .el-input {
          width: 100%;
          height: 35px;
        }
      }
    }
    .the-second-line {
      margin-top: 15px;
      position: relative;
      .query-button {
        position: absolute;
        right: 300px;
        padding: 16px 24px;
        // top: 50%;
        // transform: translate(0,-50%);
      }
     
    }
   
    :deep() {
      .el-range-editor--small.el-input__wrapper {
          height: 35px;
          line-height: 35px;  
      }
    }
  }
  .fuzzy-matching-bottom {
    height: calc(100% - 130px);
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 10px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 8px;
    
    .top-first-line {
      height: 45px;
      line-height: 45px;
        :deep(.tip-button) {
          padding: 14px 14px;
          margin: 0px 3px;
        }
      .import-export-button {
        position: absolute;
        right: 20px;
        :deep(.el-button--small) {
          padding: 16px 24px;
          border: 1px solid #569CFF;
          color: #569CFF;
        }
      }
    }
    .shanchuBtn{
      margin: 2px;
      padding: 0px;
      font-size: 15px;
      font-weight: 700;
      color: red;
    }
    .statusBtn{
      font-size: 15px;

    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      :deep() {
        // .el-checkbox.el-checkbox--small .el-checkbox__inner {
        //   width: 18px;
        //   height: 18px;
        // }
        // .el-checkbox:last-of-type {
        //   margin-right: -1px;
        // }
        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          // border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          user-select: none;
          font-size: 15px;
        }
         .manipulate {
          color: red;
          margin-right:15px;
          cursor: pointer;
          user-select: none;
        }
        .confirm,.duplicate,.revise {
          color:#1677FF;
          
        }
        .el-table th.el-table__cell>.cell {
          text-align: center;
          font-size: 16px !important;

        }
        .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
          text-align: center;

        }
      }
  
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }
}
</style>
